<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import RhsqBrowse from "./RhsqBrowse";
import RhsqEdit from "./RhsqEdit";
import RhsqForm from "./RhsqForm";
export default {
    name: "Rhsq",
    components: { RhsqBrowse, RhsqEdit, RhsqForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "RhsqEdit";
            } else if (this.editProps.showForm === true) {
                return "RhsqForm";
            } else {
                return "RhsqBrowse";
            }
        }
    }
};
</script>
